import {Label, Textarea, TextareaProps} from 'platform/components';
import {Box, HStack, Show, VStack} from 'platform/foundation';

import {FieldValues, Path, PathValue, UseFormReturn} from 'react-hook-form';

import {TestIdProps, suffixTestId} from 'shared/web';

import {PredefinedNotes} from '../PredefinedNotes/PredefinedNotes';

interface PredefinedTextAreaProps<TFieldValues extends FieldValues = FieldValues>
  extends Pick<TextareaProps, 'label' | 'onChange' | 'rows' | 'isResizable'>,
    TestIdProps {
  name: Path<TFieldValues>;
  resource: string;
  context: string;
  formApi: UseFormReturn<TFieldValues>;
  isDisabled?: boolean;
}

export function PredefinedTextArea<TFieldValues extends FieldValues = FieldValues>(
  props: PredefinedTextAreaProps<TFieldValues>
) {
  const text = props.formApi.watch(props.name);

  const onChange = (textChanged: string | null) =>
    props.formApi.setValue(props.name, textChanged as PathValue<TFieldValues, Path<TFieldValues>>);

  return (
    <VStack>
      <HStack align="flex-end">
        <Box flex={1}>
          <Show when={props.label}>
            <Label>{props.label}</Label>
          </Show>
        </Box>
        <PredefinedNotes
          note={text}
          resource={props.resource}
          context={props.context}
          onPrefill={onChange}
          isLinkVariant
          data-testid={suffixTestId('predefinedNotes', props)}
        />
      </HStack>
      <Textarea
        name={props.name}
        value={text}
        onChange={onChange}
        isResizable={props.isResizable}
        rows={props.rows ?? 1}
        isDisabled={props.isDisabled}
        data-testid={suffixTestId('note', props)}
      />
    </VStack>
  );
}
